module.exports = __webpack_public_path__ + "static/media/loaderFlights.1fc4b646.gif";